import { useLocation, useNavigate, useParams } from "react-router-dom";
import { checkBookingAvailableStatus, useCancelProgramBookingStatusWebByCancelProgramBookingStatusRequest, useGetProgramBookingWebByProgramBookingId } from "./model";
import { TopBar } from "../../../../../widgets";
import { Button, Divider, Flex, Modal, Tag, message } from "antd";
import { ReactComponent as ArrowRight } from "../../../../../assets/images/icon/arrow-right.svg"
import { ReactComponent as Warning } from '../../../../../assets/images/icon/warning.svg';
import dayjs, { Dayjs } from "dayjs";
import { Fragment, useRef, useState } from "react";
import { deepLinkBridgeElseNewTab, formatPhoneNumber, moneyStringFormatByNumber } from "../../../../../utils";
import { setUrl } from "../../../../../service";
import ProgramBookingTicketCheckModal from "./ticketCheckModal";
import { useMyContext } from "../../../../../entities/context";
import { DividerThin } from "../../../../../shared";
import { isIOS } from "react-device-detect";
import './index.css';
import { cancelProgram, requestCancelProgram, restoreCancelProgram } from "../../../../../utils/gtm";

const ProgramBookingDetail = () => {
    const location = useLocation();
    const navigate = useNavigate()
    const id = Number(useParams().id);
    const { data, isFetching } = useGetProgramBookingWebByProgramBookingId(id, 'programId programBookingId programThumbnailImageUrl programTitle programIsOnline programOnlineUrl programDescription programPeriod bookingPeriod memberId memberName memberMobile targetDateTime programIsPaid programBookingIsPaid programBookingStatus programRefundNotiHtml totalPayAmount paymentDeadline statusLastUpdatedDate bookingDateTime isDisableBooking programBookingSelectOptionList { programSelectOptionName programSelectOptionItemNameList } programBookingSubjectOptionList { programSubjectOptionName content } programBookingTicketWebResponseList { programBookingTicketCount programTicketName programTicketPayAmount programBookingTicketPrice } refundAmount receiptUrl isCreatedReview')
    const [isOpenCancelModal, setIsOpenCancelModal] = useState<boolean>(false);
    const [isOpenWithdrawCancelModal, setIsOpenWithdrawCancelModal] = useState<boolean>(false);
    const [isOpenTicketCheckModal, setIsOpenTicketCheckModal] = useState<boolean>(false);
    const topBarRef = useRef<HTMLDivElement>(null);
    const [isOpenNotCancelModal, setIsOpenNotCancelModal] = useState<boolean>(false);
    const cancelProgramBookingStatusWebByCancelProgramBookingStatusRequest = useCancelProgramBookingStatusWebByCancelProgramBookingStatusRequest()
    const { setMyReservationHistoryTabKey } = useMyContext();

    const checkPaymentDeadlineIsToday = (paymentDeadline: Dayjs) => {
        const today = dayjs().format('YYYY.MM.DD')
        const tomorrow = dayjs().add(1, 'day').format('YYYY.MM.DD')
        const targetDate = paymentDeadline.format('YYYY.MM.DD')
        if (today === targetDate) {
            return '오늘 ' + paymentDeadline.format('HH:mm')
        } else if (tomorrow === targetDate) {
            return '내일 ' + paymentDeadline.format('HH:mm')
        } else {
            return paymentDeadline.format('YYYY.MM.DD HH:mm')
        }
    }
    const clickPaymentButton = (to: string) => {
        if (!data) return;
        const state = {
            programBookingId: data.programBookingId,
            price: data.totalPayAmount,
            orderId: `program${data.programBookingId}-${dayjs().format('YYYYMMDDHHmmssZ').replaceAll('+', '').replaceAll(':', '')}`,
            orderName: `${data.programTitle} ${dayjs(data.targetDateTime).format("YYYYMMDDHHmmss")}`,
            couponId: '',
            issuedYogaCouponId: '',
            pointValue: 0,
            selectedConselingBranch: 'SEOLLEUNG',
            programBookingTicketWebResponseList: data.programBookingTicketWebResponseList,
            programBookingStatus: data.programBookingStatus,
            paymentDeadline: data.paymentDeadline,
            receiptUrl: data.receiptUrl,
        }

        setUrl(location.pathname)
        navigate(to, { state: state })
    }

    return <>
        <TopBar title="예약 상세" rightIcon={false} position='fixed' thema='dark' navigates={{ left: `/my/reservation-history/${data?.memberId}` }} />
        <div style={{ paddingInline: 20, marginTop: 32 }}>
            <div>

                {data?.programBookingStatus === '예약 대기'
                    ? <>
                        <div className="sub-title/st5 primary/p800">예약 대기중입니다</div>
                        <div className="body/b3" style={{ marginTop: 4 }}>예약이 확정되면 카카오 알림톡을 보내드립니다.</div>
                    </>
                    : data?.programBookingStatus === '결제 요청'
                        ? <>
                            <div className="sub-title/st5 primary/p800">예약 대기중입니다</div>
                            <div className="body/b3" style={{ marginTop: 4 }}><span className="error/e700">{checkPaymentDeadlineIsToday(dayjs(data.paymentDeadline))}</span> 까지 결제를 완료해주세요.</div>
                        </>
                        : data?.programBookingStatus === '예약 확정'
                            ? <>
                                <div className="sub-title/st5">예약이 확정되었습니다</div>
                            </>
                            : data?.programBookingStatus === '취소 요청'
                                ? <>
                                    <div className="sub-title/st5">취소를 요청했습니다</div>
                                    <div className="body/b3" style={{ marginTop: 4 }}>환불 가능 여부를 확인해 안내드립니다.</div>
                                </>
                                : data?.programBookingStatus === '참석'
                                    ? <>
                                        <div className="sub-title/st5">이용을 완료했습니다</div>
                                    </>
                                    : data?.programBookingStatus === '불참'
                                        ? <>
                                            <div className="sub-title/st5">이용을 완료했습니다</div>
                                        </>
                                        : data?.programBookingStatus === '환불 완료'
                                            ? <>
                                                <div className="sub-title/st5">환불이 완료되었습니다</div>
                                            </>
                                            : data?.programBookingStatus === '취소 완료'
                                                ? <>
                                                    <div className="sub-title/st5">예약을 취소했습니다</div>
                                                </>
                                                : '---'}
            </div>

            <div style={{ marginTop: 20, padding: 12, backgroundColor: 'var(--secondarys100)', borderRadius: 4 }} onClick={() => navigate(`/wellness-program/${data?.programId}`)}>
                <Flex justify="space-between" align='center' gap={16}>
                    <Flex align='center' gap={16}>
                        <div style={{ width: 56, height: 56, minWidth: 56 }}>
                            <img src={data?.programThumbnailImageUrl} alt="프로그램 이미지" width={'100%'} height={'100%'} style={{ borderRadius: 2, objectFit: 'cover' }} />
                        </div>
                        <div className="sub-title/st3">{data?.programTitle}</div>
                    </Flex>
                    <div style={{ width: 32, height: 32 }}>
                        <ArrowRight width={16} height={16} stroke="var(--secondarys400)" style={{ padding: 8 }} />
                    </div>
                </Flex>
            </div>

            <div style={{ marginTop: 24, marginBottom: 16 }} className="sub-title/st3">예약 세부 정보</div>
            <div style={{ paddingTop: 8 }} className="body/b2 secondary/s500">이용 일시</div>
            <div style={{ paddingBottom: 8 }} className="body/b3">{dayjs(data?.targetDateTime).format("YYYY.MM.DD (ddd) HH:mm")}</div>
            <div style={{ paddingTop: 8 }} className="body/b2 secondary/s500">{data?.programIsPaid ? '티켓' : '인원'}</div>
            {data?.programIsPaid
                ? data?.programBookingTicketWebResponseList
                    .filter(bookingTicket => bookingTicket.programBookingTicketCount > 0)
                    .map((bookingTicket, idx) => <Flex key={idx} style={{ paddingBottom: 8 }} >
                        <div className="body/b3" style={{ width: 200 }}>{bookingTicket.programTicketName}</div>
                        <div className="body/b3">{bookingTicket.programBookingTicketCount}명</div>
                    </Flex>)
                : data?.programBookingTicketWebResponseList
                    .filter(bookingTicket => bookingTicket.programBookingTicketCount > 0)
                    .map((bookingTicket, idx) => <div key={idx} style={{ paddingBottom: 8 }} className="body/b3">{bookingTicket.programBookingTicketCount}명</div>)}
            <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', marginBlock: 12 }} />
            <div style={{ paddingTop: 8 }} className="body/b2 secondary/s500">이름</div>
            <div style={{ paddingBottom: 8 }} className="body/b3">{data?.memberName}</div>
            <div style={{ paddingTop: 8 }} className="body/b2 secondary/s500">연락처</div>
            <div style={{ paddingBottom: 8 }} className="body/b3">{formatPhoneNumber(data?.memberMobile ?? '')}</div>
            {((data?.programBookingSelectOptionList?.length ?? 0) + (data?.programBookingSubjectOptionList?.length ?? 0)) > 0 && <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', marginBlock: 12 }} />}
            {(data?.programBookingSelectOptionList.length !== 0 || data?.programBookingSubjectOptionList.length !== 0) &&
                <div>
                    {data?.programBookingSelectOptionList.map((selectOption, idx) => <Fragment key={idx}>
                        <div style={{ paddingTop: 8 }} className="body/b2 secondary/s500">{selectOption.programSelectOptionName}</div>
                        <div style={{ paddingBottom: 8 }} className="body/b3">{selectOption.programSelectOptionItemNameList.join(', ')}</div>
                    </Fragment>)}
                    {data?.programBookingSubjectOptionList.map((subjectOption, idx) => <Fragment key={idx}>
                        <div style={{ paddingTop: 8 }} className="body/b2 secondary/s500">{subjectOption.programSubjectOptionName}</div>
                        <div style={{ paddingBottom: 8 }} className="body/b3 base-black">{subjectOption.content}</div>
                    </Fragment>)}
                </div>}
            {data?.programBookingStatus === '취소 완료' &&
                <div>
                    {data?.programIsPaid === true && <>
                        <DividerThin style={{ marginBlock: 16 }} />
                        <Flex justify="space-between" style={{ alignItems: 'center' }} >
                            <div>
                                <div className="body/b2 secondary/s500">결제 예정 금액</div>
                                <div className="body/b3">{moneyStringFormatByNumber(data?.totalPayAmount ?? 0)} 원</div>
                            </div>
                        </Flex>
                    </>}
                    <DividerThin style={{ marginBlock: 16 }} />
                    <div className="body/b2 secondary/s500">취소일시</div>
                    <div className="body/b3 base/black">{dayjs(data?.statusLastUpdatedDate).format('YYYY.MM.DD HH:mm')}</div>
                </div>}
        </div>
        {data?.programBookingStatus !== '취소 완료' && data?.programIsPaid === true &&
            <>
                <Divider style={{ borderBlockStart: '6px solid var(--secondarys100)', marginBlock: 24 }} />
                <div style={{ padding: '0 20px' }}>
                    <Flex justify="space-between">
                        <div className="sub-title/st3">{data?.programBookingStatus === '환불 완료' ? '환불 정보' : '결제 정보'}</div>
                        {data?.programBookingStatus === '예약 확정' || data?.programBookingStatus === '참석' || data?.programBookingStatus === '불참'
                            ? <Tag style={{ margin: 0 }} bordered={false}>결제 완료</Tag>
                            : data?.programBookingStatus === '결제 요청'
                                ? <Tag style={{ margin: 0 }} bordered={false} color="error">결제 필요</Tag>
                                : data?.programBookingStatus === '환불 완료'
                                    ? <Tag style={{ margin: 0 }} bordered={false} color="error">환불 완료</Tag>
                                    : <></>}
                    </Flex>
                    <Flex justify="space-between" style={{ alignItems: 'center', marginTop: 16, cursor: 'pointer' }} onClick={() => clickPaymentButton(data?.programBookingStatus === '환불 완료' ? `/program-booking-refund/${id}` : '/program/book/detail/pay-info')}>
                        <div>
                            <div className="body/b2 secondary/s500">{data?.programBookingStatus === '환불 완료' ? '환불금액' : '결제 예정 금액'}</div>
                            <div className="body/b3">{data?.programBookingStatus === '환불 완료' ? data?.refundAmount?.toLocaleString() : moneyStringFormatByNumber(data?.totalPayAmount ?? 0)} 원</div>
                        </div>
                        <ArrowRight width={16} height={16} stroke="var(--secondarys400)" style={{ padding: 8 }} />
                    </Flex>
                </div>
            </>}


        <Divider style={{ borderBlockStart: '6px solid var(--secondarys100)', marginBlock: 24 }} />
        <div style={{ padding: '0 20px 24px 20px' }}>
            <div className="sub-title/st3" style={{ paddingBottom: 16 }}>취소・환불 규정</div>
            {data && <div className="body/b3 secondary/s850 wellness-program-booking-detail-container" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: data.programRefundNotiHtml }} />}
        </div>
        <div style={{ padding: 20, paddingBottom: isIOS ? 46 : 20 }}>
            {data?.programBookingStatus === '예약 대기'
                ? <Button className="sub-title/st2 secondary/s600" color="default" variant="text" style={{ width: '100%', height: '50px', marginTop: 10, border: '1px solid var(--secondarys400)', borderRadius: 4 }} onClick={() => setIsOpenCancelModal(true)}>취소하기</Button>
                : data?.programBookingStatus === '결제 요청'
                    ? <>
                        <Button className="sub-title/st3 base/white" color="default" variant="solid" style={{ width: '100%', height: '50px' }} onClick={() => clickPaymentButton(`/program-booking-checkout/${data.programBookingId}`)}>결제하기</Button>
                        <Button className="sub-title/st2 secondary/s600" color="default" variant="text" style={{ width: '100%', height: '50px', marginTop: 10, border: 'none' }} onClick={() => setIsOpenCancelModal(true)}>취소하기</Button>
                    </>
                    : data?.programBookingStatus === '취소 요청'
                        ? <>
                            <Button className="sub-title/st2 secondary/s600" color="default" variant="outlined" style={{ width: '100%', height: '50px', marginTop: 10, border: '1px solid var(--secondarys400)', borderRadius: 4 }} onClick={() => setIsOpenWithdrawCancelModal(true)}>취소 철회하기</Button>
                        </>
                        : data?.programBookingStatus === '예약 확정'
                            ? dayjs(data?.targetDateTime).format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD')
                                ? <>
                                    {data.programIsOnline
                                        ? <Button className="sub-title/st3 base/white" color="default" variant="solid" style={{ width: '100%', height: '50px' }} onClick={() => deepLinkBridgeElseNewTab(data.programOnlineUrl)}>온라인 프로그램 바로가기</Button>
                                        : <Button className="sub-title/st3 base/white" color="default" variant="solid" style={{ width: '100%', height: '50px' }} onClick={() => setIsOpenTicketCheckModal(true)}>티켓 확인하기</Button>}
                                    <div className="sub-title/st3 secondary/s400" style={{ display: 'flex', justifyContent: 'center', gap: 8, paddingBlock: '16px', marginTop: '16px', border: '1px solid var(--secondarys200)', borderRadius: '4px', cursor: 'pointer' }} onClick={() => setIsOpenNotCancelModal(true)}>
                                        <div>
                                            취소 불가
                                        </div>
                                        <Warning width={16} height={16} fill="var(--secondarys400)" />
                                    </div>
                                </>
                                : <>
                                    {data.programIsOnline
                                        ? <Button className="sub-title/st3 base/white" color="default" variant="solid" style={{ width: '100%', height: '50px' }} onClick={() => deepLinkBridgeElseNewTab(data.programOnlineUrl)}>온라인 프로그램 바로가기</Button>
                                        : <Button className="sub-title/st3 base/white" color="default" variant="solid" style={{ width: '100%', height: '50px' }} onClick={() => setIsOpenTicketCheckModal(true)}>티켓 확인하기</Button>}
                                    <Button className="sub-title/st2 secondary/s600" color="default" variant="outlined" style={{ width: '100%', height: '50px', marginTop: 10, border: 'none' }} onClick={() => setIsOpenCancelModal(true)}>
                                        {data.programIsPaid ? '취소 요청하기' : '취소 하기'}
                                    </Button>
                                </>
                            : data?.programBookingStatus === '참석'
                                ? data?.isCreatedReview
                                    ? <>
                                        <Button className="sub-title/st2 secondary/s600" color="default" variant="outlined" style={{ width: '100%', height: '50px', marginTop: 10, border: '1px solid var(--secondarys400)', borderRadius: 4 }} onClick={() => navigate(`/review/program/update/${data.programBookingId}`)}>
                                            작성한 리뷰 보기
                                        </Button>
                                    </>
                                    : <>
                                        <Button className="sub-title/st2 secondary/s600" color="default" variant="outlined" style={{ width: '100%', height: '50px', marginTop: 10, border: '1px solid var(--secondarys400)', borderRadius: 4 }} onClick={() => navigate(`/review/program/create/${data.programBookingId}`)}>
                                            리뷰 작성하기
                                        </Button>
                                    </>
                                : data?.programBookingStatus === '불참' || data?.programBookingStatus === '환불 완료'
                                    ? <></>
                                    : data?.programBookingStatus === '취소 완료' && !data.isDisableBooking &&
                                    <Button className="sub-title/st3 secondary/s600" color="default" variant="outlined" style={{ width: '100%', height: '50px', border: '1px solid var(--secondarys400)', borderRadius: 4, marginTop: 10, marginBottom: 40 }} onClick={() => navigate(`/wellness-program/${data.programId}`)}>
                                        다시 예약하기
                                    </Button>}
        </div>

        <Modal
            open={isOpenCancelModal}
            closable={false}
            centered
            styles={{ content: { borderRadius: 4, padding: '20px 16px', marginInline: 12 } }}
            onCancel={() => setIsOpenCancelModal(false)}
            footer={[
                <Flex key="footer-buttons" style={{ marginTop: '16px' }} gap={16}>
                    <Button
                        className={data && data.programIsPaid && data?.programBookingStatus === '예약 확정' ? "sub-title/st3 secondary/s600" : "sub-title/st2 secondary/s600"}
                        key="back"
                        onClick={() => setIsOpenCancelModal(false)}
                        style={{ width: '50%', height: '50px', backgroundColor: 'white', border: '1px solid var(--secondarys400)', borderRadius: 4 }}>
                        돌아가기
                    </Button>
                    <Button
                        className="sub-title/st3 base/white"
                        type="primary"
                        key="submit"
                        loading={cancelProgramBookingStatusWebByCancelProgramBookingStatusRequest.isPending}
                        onClick={() => {
                            const cancelParams: ICancelProgramBookingStatusRequest = {
                                programBookingId: id,
                                status: data && data.programIsPaid && data?.programBookingStatus === '예약 확정' ? "REQUEST_CANCEL" : "CANCEL"
                            }

                            cancelProgramBookingStatusWebByCancelProgramBookingStatusRequest.mutate(cancelParams, {
                                onSuccess: res => {
                                    if (!data) return
                                    if (!res.data.errors) {
                                        const title = data.programTitle;
                                        const type = data.programIsOnline ? '온라인' : '오프라인';
                                        const ticketName = data.programIsPaid ? data.programBookingTicketWebResponseList.map(q => q.programTicketName).join(',') : '-';
                                        const quantity = data.programBookingTicketWebResponseList.reduce((acc, ticket) => acc + ticket.programBookingTicketCount, 0);
                                        const price = data.programIsPaid ? data.programBookingTicketWebResponseList.reduce((acc, ticket) => acc + (ticket.programBookingTicketCount * ticket.programBookingTicketPrice), 0) : 0;
                                        const date = dayjs(data.targetDateTime).format('YYYY.MM.DD');
                                        const time = dayjs(data.targetDateTime).format('hh:mm');
                                        const requestDate = dayjs(data.statusLastUpdatedDate).format('YYYY.MM.DD');
                                        if (data && data.programIsPaid && data?.programBookingStatus === '예약 확정') {

                                            requestCancelProgram(title, type, ticketName, quantity, price, date, time, requestDate)
                                            navigate(`/my/reservation-history/${data?.memberId}`)
                                        } else {
                                            const reserveState = data.programBookingStatus === "PENDING" ? "예약대기" : data.programBookingStatus === "REQUEST_PAID" ? "결제대기" : "예약확정"
                                            const isPaid = data.programIsPaid ? '유료' : '무료'
                                            cancelProgram(title, reserveState, isPaid, type, ticketName, quantity, price, date, time, requestDate)

                                            setMyReservationHistoryTabKey(3)
                                            navigate(`/my/reservation-history/${data?.memberId}`, { state: { status: 'cancel-success' } })
                                        }
                                    } else {
                                        // message.error('에러가 발생했습니다 개발팀에 문의해주세요')
                                    }
                                }
                            })
                        }}
                        style={{ width: '50%', height: '50px', margin: 0, borderWidth: '1px', borderRadius: 4 }}>
                        {data && data.programIsPaid && data?.programBookingStatus === '예약 확정' ? '취소 요청' : '예약 취소'}
                    </Button>
                </Flex>
            ]}>
            <div>
                <div className="sub-title/st4" style={{ textAlign: 'center' }}>
                    {data && data.programIsPaid && data?.programBookingStatus === '예약 확정' ? '예약 취소 요청' : '예약 취소'}
                </div>
                <div className="body/b2 secondary/s800" style={{ marginTop: 8, textAlign: 'center', whiteSpace: 'pre-line' }}>
                    {data && data.programIsPaid && data?.programBookingStatus === '예약 확정' ? '프로그램 예약 취소를 요청하시겠습니까?\n접수 후 환불 가능 여부를 확인해 안내드립니다.\n(영업일 2-3일 소요)' : '프로그램 예약을 취소하시겠습니까?'}
                </div>
            </div>
        </Modal>

        <Modal
            open={isOpenWithdrawCancelModal}
            closable={false}
            centered
            onCancel={() => setIsOpenWithdrawCancelModal(false)}
            styles={{ content: { borderRadius: 4, padding: '20px 16px', marginInline: 12 } }}
            footer={[
                <Flex key="footer-buttons" style={{ marginTop: '16px' }} gap={16}>
                    <Button
                        key="back"
                        className="sub-title/st3 secondary/s600"
                        onClick={() => setIsOpenWithdrawCancelModal(false)}
                        style={{ width: '50%', height: '50px', backgroundColor: 'white', border: '1px solid var(--secondarys400)', borderRadius: 4 }}>
                        돌아가기
                    </Button>
                    <Button
                        loading={cancelProgramBookingStatusWebByCancelProgramBookingStatusRequest.isPending}
                        type="primary"
                        key="submit"
                        className="sub-title/st3 base/white"
                        onClick={() => {
                            const cancelParams: ICancelProgramBookingStatusRequest = {
                                programBookingId: id,
                                status: 'COMPLETE'
                            }

                            cancelProgramBookingStatusWebByCancelProgramBookingStatusRequest.mutate(cancelParams, {
                                onSuccess: res => {
                                    if (!data) return
                                    if (!res.data.errors) {
                                        const title = data.programTitle;
                                        const type = data.programIsOnline ? '온라인' : '오프라인';
                                        const ticketName = data.programIsPaid ? data.programBookingTicketWebResponseList.map(q => q.programTicketName).join(',') : '-';
                                        const quantity = data.programBookingTicketWebResponseList.reduce((acc, ticket) => acc + ticket.programBookingTicketCount, 0);
                                        const price = data.programIsPaid ? data.programBookingTicketWebResponseList.reduce((acc, ticket) => acc + (ticket.programBookingTicketCount * ticket.programBookingTicketPrice), 0) : 0;
                                        const date = dayjs(data.targetDateTime).format('YYYY.MM.DD');
                                        const time = dayjs(data.targetDateTime).format('hh:mm');
                                        const requestDate = dayjs(data.bookingDateTime).format('YYYY.MM.DD');
                                        const requestCancelDate = dayjs(data.statusLastUpdatedDate).format('YYYY.MM.DD');
                                        restoreCancelProgram(title, type, ticketName, quantity, price, date, time, requestDate, requestCancelDate)
                                        navigate(`/my/reservation-history/${data?.memberId}`, { state: { status: 'cancel-success' } })
                                    } else {
                                        // message.error('에러가 발생했습니다 개발팀에 문의해주세요')
                                    }
                                }
                            })
                        }}
                        style={{ width: '50%', height: '50px', margin: 0, borderWidth: '1px', borderRadius: 4 }}>
                        요청 철회
                    </Button>
                </Flex>
            ]}>
            <div>
                <div className="sub-title/st4" style={{ textAlign: 'center' }}>
                    취소 요청 철회
                </div>
                <div className="body/b2 secondary/s800" style={{ marginTop: 8, textAlign: 'center', whiteSpace: 'pre-line' }}>
                    <div>요청하신 예약 취소를 철회하시겠습니까?</div>
                    <Flex justify="center">
                        <Tag color="#000000" style={{ padding: '2px 5px' }}>예약확정</Tag>
                        <div>상태로 변경됩니다.</div>
                    </Flex>
                </div>
            </div>
        </Modal>

        <Modal
            open={isOpenNotCancelModal}
            closable={false}
            centered
            onCancel={() => setIsOpenNotCancelModal(false)}
            styles={{ content: { borderRadius: 4, padding: '20px 16px', marginInline: 12 } }}
            footer={[
                <Flex key="footer-buttons" style={{ marginTop: '16px' }} gap={16}>
                    <Button
                        className="sub-title/st3 secondary/s600"
                        onClick={() => setIsOpenNotCancelModal(false)}
                        style={{ width: '50%', height: '50px', backgroundColor: 'white', border: '1px solid var(--secondarys400)', borderRadius: 4 }}>
                        돌아가기
                    </Button>
                    <Button
                        className="sub-title/st3 base/white"
                        loading={cancelProgramBookingStatusWebByCancelProgramBookingStatusRequest.isPending}
                        type="primary"
                        onClick={() => deepLinkBridgeElseNewTab('https://pf.kakao.com/_xmWxbYG/chat')}
                        style={{ width: '50%', height: '50px', margin: 0, borderWidth: '1px', borderRadius: 4 }}>
                        컨시어지 문의
                    </Button>
                </Flex>
            ]}>
            <div>
                <div className="sub-title/st4" style={{ textAlign: 'center' }}>
                    취소 불가
                </div>
                <div className="body/b2 secondary/s800" style={{ marginTop: 8, textAlign: 'center' }}>
                    프로그램 이용당일은 취소가 불가합니다.<br />
                    컨시어지에 문의해주세요.
                </div>
            </div>
        </Modal>

        <ProgramBookingTicketCheckModal open={isOpenTicketCheckModal} setOpen={setIsOpenTicketCheckModal} programBookingId={id} imageUrl={data?.programThumbnailImageUrl ?? ''} />
    </>
}
export default ProgramBookingDetail